import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { API_HOTLIST_REASONS } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import * as R from 'ramda';
import { HotlistReason } from './hotlistReason';
import { assoc } from '../../language/module';


const KEY_ACTION = ACTION_TYPE.GET_HOTLIST_REASONS_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_HOTLIST_REASONS_REQUEST,
  ACTION_TYPE.GET_HOTLIST_REASONS_RESPONSE,
  ACTION_TYPE.GET_HOTLIST_REASONS_ERROR,
];


/**
 * Constructs an action that can be dispatched to get the complete list of hotlist reasons, including reason 0, which
 * is that the guest isn't hotlisted.
 */
export const getHotlistReasonsAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: API_HOTLIST_REASONS,
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!R.path([ 'hotlistReasons', 'isLoading' ], state) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<HotlistReason[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return assoc('hotlistReasons', { isLoading: true, error: undefined }, state);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return assoc('hotlistReasons', { isLoading: false, error: error }, withBreaker);
  }

  return assoc(
    'hotlistReasons',
    {
      isLoading: false,
      error:     undefined,
      reasons:   (payload || []).filter(reason => reason.accessHotlistCode !== 0),
    },
    withBreaker,
  );
};


export const getHotlistReasonsReducer = makeApiReducer<HotlistReason[]>(ACTIONS, KEY_ACTION, reducer);
